
import {BrowserEventType, ViewerEventType} from './viewer.event.type';

export type EventHandler     = (event: ViewerEvent) => void;

/**
 *
 * @class ViewerEvent
 *
 * base class for events
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      May 2023
 *
 */
export class ViewerEvent {

  /** unique event id */
  public id: number                           = 0;

  /** the original browser even (if appropriate */
  public original: BrowserEventType           = null;

  /** the kind of event */
  public type: ViewerEventType                = ViewerEventType.NONE;

  /** milliseconds timestamp */
  public timestamp: number                    = 0;

  /** any custom data for the event */
  public data: any                            = {};

  /** standard constructor */
  constructor(init?: Partial<ViewerEvent>) {

    Object.assign(this, init);
  }

  /** fetch the original browser event; won't exist for all possible events */
  public getOriginalEvent(): BrowserEventType {

    return this.original;
  }

  /** force the original event */
  public setOriginalEvent(event: BrowserEventType): ViewerEvent {

    this.original = event;

    return this;
  }

  /** fetch the event type */
  public getType(): ViewerEventType {

    return this.type;
  }

  /** force the even type */
  public setType(type: ViewerEventType): ViewerEvent {

    return this;
  }

  /** fetch the timestamp */
  public getTimestamp(): number {

    return this.timestamp;
  }


  /** force the timestamp */
  public setTimestamp(timestamp: number): ViewerEvent {

    this.timestamp = timestamp;

    return this;
  }


}
